import React from "react";
import { Icon } from "@iconify/react";

const SingleImagePreview = ({ src = "", show = false, onClose = () => {} }) => {
  if (!show || !src) return null;

  return (
    <div
      className="single-preview-backdrop fade-in"
      onClick={onClose} // click outside closes
    >
      <div
        className="single-preview-container zoom-in"
        onClick={(e) => e.stopPropagation()} // prevent close when clicking image
      >
        <button className="close-btn" onClick={onClose}>
          <Icon icon="mdi:close" width="22" />
        </button>

        <img src={src} alt="Preview" className="single-preview-image" />
      </div>
    </div>
  );
};

export default SingleImagePreview;
